<script setup lang="ts">
import { ref } from 'vue'
import FormField from '@/components/app/FormField.vue'
import { Input } from '@/components/ui/input'

/**
 * Champ de code court (TOTP, OTP e-mail, code de secours) — `one-time-code` pour
 * l'autofill. `digits` impose le clavier numérique ; sans lui, le champ accepte un code
 * de secours (`XXXXX-XXXXX`).
 */
defineProps<{ label: string; error: string; hint?: string; digits?: number }>()
const model = defineModel<string>({ default: '' })
const emit = defineEmits<{ clear: [] }>()
const input = ref<InstanceType<typeof Input> | null>(null)

defineExpose({ focus: () => (input.value?.$el as HTMLInputElement | undefined)?.focus() })
</script>

<template>
  <FormField v-slot="{ id, invalid, describedBy }" :label="label" :error="error" :hint="hint">
    <Input
      :id="id"
      ref="input"
      v-model="model"
      :inputmode="digits ? 'numeric' : 'text'"
      :maxlength="digits ?? undefined"
      autocomplete="one-time-code"
      :class="digits ? 'text-center text-lg tracking-[0.4em]' : ''"
      :aria-invalid="invalid || undefined"
      :aria-describedby="describedBy"
      @input="emit('clear')"
    />
  </FormField>
</template>
